import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { setFilter } from '@pages/filter/store/slice';
import { Filter as FilterModel } from '@api/user/types/Filter';
import { useGetFullFilterQuery, useResetFullFilterMutation, useLazyGetUserDataQuery, useResetUserDataMutation } from '@api/user/api';
import { hasOwnPropertyTS } from '@utils/typescriptGuards';
import { AppPage } from 'components/app-page/AppPage';
import FilterOptions from '@pages/filter/FilterOptions';
import FilterButtons from '@pages/filter/FilterButtons';



export const Filter = () => {

	const hasPermission = useHasPermission();
	const dispatch = useDispatch();
	const updateFilter = (filter: FilterModel) => dispatch(setFilter(filter));

	const [ getUserData, { data, isLoading, isFetching, isError, isSuccess, error } ] = useLazyGetUserDataQuery();
	const { isLoading: fIsLoading, isFetching: fIsFetching, isError: fIsError } = useGetFullFilterQuery();
	const [ resetFullFilter ] = useResetFullFilterMutation();
	const [ resetUserData ] = useResetUserDataMutation();

	
	useEffect(() => {
		getUserData();
	}, []);


	useEffect(() => {
		if (isSuccess && data) {
			updateFilter(data.filter);
		}
	}, [ isSuccess, data ]);

	
	const resetAllApi = useCallback(() => {
		resetFullFilter();
		resetUserData();
	},[]);

	
	return (
		<AppPage
			isError={Boolean(
				fIsError ||
				(isError && error && hasOwnPropertyTS(error, 'originalStatus') && error.originalStatus !== 404)
			)}
			isLoading={isLoading || isFetching || fIsLoading || fIsFetching}
			className='filter-page'
			pageLabel='Filtr'
			resetPageApi={resetAllApi}
		>
			<div className='filter-content'>
				<FilterButtons disableModify={!hasPermission(AppRolesEnum.userData_Modify)} />
				<FilterOptions disableModify={!hasPermission(AppRolesEnum.userData_Modify)} />
			</div>
		
		</AppPage>
	)
}

export default Filter;